import React from 'react';

const NotFound = () => {
    return (
        <div className='register'>
            <h1>404</h1>
            <p>Your search field is not available</p>
        </div>
    );
};

export default NotFound;